// extracted by mini-css-extract-plugin
export default {"cls1":"jqkhu2YV5akM6FED3G8m","cls2":"TaEhIhjxop2SrHSFqEF0 jqkhu2YV5akM6FED3G8m","isTabletDown":"BtpVlB1Oc_b0osOuL49w","isDesktopUp":"Goi3IoSCP0psAOzjqXsi"};